/**
 * Env-driven feature flags.
 *
 * `aiAssistant` mirrors whether the backend has an `ANTHROPIC_API_KEY`
 * configured. The browser cannot read a backend env, so this is a build-time
 * flag that has to be set per environment alongside the real key — when it is
 * off, the assistant panel drops the Chats and Dashboards tabs and shows only
 * AI processing, which does not go through the model.
 *
 * Deliberately strict (`=== 'true'`): an unset flag means "no key", so a new
 * environment hides the assistant until it is switched on explicitly, rather
 * than shipping a chat that errors on every message.
 */
/**
 * `onboarding` gates the first-run tours. Opposite polarity to `aiAssistant` on
 * purpose: tours are on unless an environment turns them off, because forgetting
 * to enable them ships a product nobody is shown, while forgetting to disable
 * them costs one skipped tour.
 *
 * Set `VITE_IS_ONBOARDING_ENABLED=false` for E2E. A tour mounts an overlay that
 * blocks clicks until it is dismissed, so a signed-in test session — which is
 * exactly a first-time user — would have every click land on the overlay.
 */
export const flags = {
  aiAssistant: import.meta.env.VITE_AI_ASSISTANT_ENABLED === 'true',
  onboarding: import.meta.env.VITE_IS_ONBOARDING_ENABLED !== 'false',
};
